import React, {useState, useEffect} from 'react';
import './ProfileChange.css';
import {Button} from '@material-ui/core';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import db, {storage} from './firebase';

function ProfileChange({click}) {
    const [phone, setPhoto] = useState('');
    const [profile, setProfile] = useState('');
    const handleChange = (e) => {
        setPhoto(e.target.files[0])
    }
    const profileChange = (e) => {
        setProfile(e.target.files[0])
    }
    if(phone) {
        const reader = new FileReader()
        reader.addEventListener('load', function() {
            document.getElementById('cover__acco').style.background = `url(${this.result})`
        })
        reader.readAsDataURL(phone)
    }
    if(profile) {
        const reader = new FileReader()
        reader.addEventListener('load', function() {
            document.getElementById('profile__acco').style.background = `url(${this.result})`
        })
        reader.readAsDataURL(profile)
    }
    const usmail = localStorage.getItem('usermail')
    const [uudd, setUudd] = useState([])
    console.log(usmail)
    useEffect(() => {
        db.collection('users').where('email','==',usmail).
        onSnapshot(snapshot => setUudd(snapshot.docs.map((doc)=>({
            id:doc.id, data:doc.data()
        }))))
    }, [])
    var iidd = ""
    uudd.map(ud=>{
        iidd = ud.id
    })
    console.log(iidd)
    const nstep = (event) => {
        event.preventDefault()
        if(!phone) {
            db.collection('users').doc(`${iidd}`).update({
                coverImage:''
            })
        } else {
        const uploadTask = storage.ref(`users/${phone.name}`).put(phone);
        uploadTask.on (
            "state_changed",
            snapshot => {},
            error => {
                console.log(error);
            },
            () => {
                storage
                .ref("users")
                .child(phone.name)
                .getDownloadURL()
                .then(url => {
                    db.collection('users').doc(`${iidd}`).update({
                        coverImage:url
                    })
                });
            }
        )
        }

        if(!profile) {
            db.collection('users').doc(`${iidd}`).update({
                profileImage:''
            })
        } else {
        const uploadTas = storage.ref(`users/${profile.name}`).put(profile);
        uploadTas.on (
            "state_changed",
            snapshot => {},
            error => {
                console.log(error);
            },
            () => {
                storage
                .ref("users")
                .child(profile.name)
                .getDownloadURL()
                .then(url => {
                    db.collection('users').doc(`${iidd}`).update({
                        profileImage:url
                    })
                });
            }
        )
        }
        
        click()
    }
    return (
        <div className="profileChange">
            <form>
                <div className="cover__acc" id="cover__acco"
                style={{background:"black"}}
                >
                    <input type="file" 
                    onChange={handleChange}
                    />
                    <CameraAltIcon className="camera__photo"/>
                </div>
                <div className="profile__acc" id="profile__acco">
                    <input type="file" 
                    onChange={profileChange}
                    />
                    <CameraAltIcon className="camera__photo cp"/>
                </div>
                <Button onClick={nstep} 
                disabled={!phone || !profile}
                type="submit">Next Step</Button>
            </form>
        </div>
    )
}

export default ProfileChange
